export default function createMessageHandler(handlers) {
  return ({ message, ...rest }) => dispatch => {
    const handler = handlers[message.data.value.id];
    if (handler) {
      dispatch(handler({ message, ...rest }));
    }
  };
}
